import { render, staticRenderFns } from "./FaceAccreditationCard.vue?vue&type=template&id=20469192&"
import script from "./FaceAccreditationCard.ts?vue&type=script&lang=ts&"
export * from "./FaceAccreditationCard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports